import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { MakingDataService } from './md/service/making-data.service';
import { FirebaseMessagingService } from './firebase-messaging.service';
@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  login_with_password = environment.loginWithPassword || true;

  apiHost = environment.apiHost || "https://localhost"
  apiPort = environment.apiPort || "3306"
  version = "22-05-2021";
  httpUrl: any;
  profile_data = '';
  uiHost = environment.apiHost || "https://localhost"
  apiProtocol: any
  slashUrl = ['dev.acms.upda.co.in', 'acms.upda.co.in',]
  constructor(private http: HttpClient, private mds: MakingDataService, private fcm: FirebaseMessagingService) {
    this.uiHost = window.location.hostname;
    ////////////////////////////
    // decide protocol based on window location



    if (this.uiHost === "localhost") {
      this.apiProtocol = "http";

    }
    else {

      this.apiProtocol = "https";
    }



    if (this.uiHost.startsWith("dev.acms.upda.co.in")) {
      this.uiHost = 'dev.acms.upda.co.in';
      this.apiPort = 'api';
      this.login_with_password = true;
    }
    else if (this.uiHost.startsWith("acms.upda.co.in")) {
      this.uiHost = 'acms.upda.co.in';
      this.apiPort = 'api';
      this.login_with_password = true;

    }
    // else if (this.uiHost.startsWith("newerp.upneda.co")) {
    //   this.uiHost = 'newerp.upneda.co';
    //   this.apiPort = '3046';

    // }
    else {
      this.uiHost = 'localhost';
    }

    if (this.slashUrl.includes(this.uiHost)) {
      this.httpUrl = this.apiProtocol + '://' + this.uiHost + '/' + this.apiPort;
    }
    else {
      this.httpUrl = this.apiProtocol + '://' + this.uiHost + ':' + this.apiPort;
    }
  }

  allLanguage: any = []
  allLableShowObj: any = {};
  allLabel: any = [];
  language_cd: any;
  allLableShowObjProp: any = {};
  allLabelProp: any = [];
  allLableShowObjHR: any = {};
  allLabelHR: any = [];
  allLableShowObjSA: any = {};
  allLabelSA: any = [];
  allSystemModuleObj: any = {};
  changeLanguage() {
    if (this.language_cd == null || this.language_cd == undefined) {
      this.language_cd = 'ENG'
    }
  }

  async getSystemModule() {
    let obj: any = new Object();
    obj['b_acct_id'] = 0;
    var resp = await this.getModules(JSON.stringify(obj));
    if (resp['error'] == false) {
      obj = new Object();
      for (let i = 0; i < resp.data.length; i++) {
        obj[resp.data[i]['module_cd']] = resp.data[i]['module_name']
      }
      this.allSystemModuleObj = obj;

    } else {

    }
  }


  async getAssignModules(b_acct_id: any, role_cd: any) {
    let obj: any = new Object();
    obj['b_acct_id'] = b_acct_id;
    obj['role_cd'] = role_cd;
    var resp = await this.getAllAssignModules(JSON.stringify(obj));
    if (resp['error'] == false) {
      //  obj = new Object();
      // for (let i = 0; i < resp.data.length; i++) {
      //   obj[resp.data[i]['module_cd']] = resp.data[i]['module_name']
      // }
      // this.allSystemModuleObj = obj;
      // console.log( resp.data)
      return resp.data
    } else {
      return []
    }
  }


  async signUp(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/signup', obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }



  async login(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/login', obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getAllLanguages(obj: any) {
    const res = await this.http.get<any>(this.httpUrl + '/systemdata/languages/getAllLanguages' + obj).toPromise().then(res => {
      return res;
    });
    return res;
  }

  async getAllAssignModules(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/md/resource/getAssignModules' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }


  async getModules(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/admin/resource/getmodules' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getserver(obj: any) {
    try {
      const res = await this.http.get<any>(this.httpUrl + '/').toPromise().then(res => {
        return res;
      })
      return res;
    } catch (error) {
      return { 'error': true };
    }

  }

  async getcomponentLabelvalueswithLanguage(obj: any) {
    const res = await this.http.get<any>(this.httpUrl + '/systemdata/languages/getcomponentLabelvalueswithLanguage' + obj).toPromise().then(res => {
      return res;
    });
    return res;
  }

  // async getcomponentLabelvalueswithLanguage1(obj) {
  //   const res = await this.http.get<any>(this.httpUrl + '/systemdata/languages/getcomponentLabelvalueswithLanguage1' + obj).toPromise().then(res => {
  //     return res;
  //   });
  //   return res;
  // }

  //   async sendMsg(mobile) {
  //     var str = "https://2factor.in/API/V1/" + this.api_key + "/SMS/" + mobile + "/AUTOGEN"
  //     const resp = await this.http.get<any>(str).toPromise().then(res => {
  //       return res;
  //     });
  //     return resp;

  //   }

  async sendMsg(mobile: any) {
    let obj: any = new Object();
    obj['mobile'] = mobile;
    const resp = await this.http.get<any>(this.httpUrl + '/systemdata/authentication/sendOTPMsg' + JSON.stringify(obj)).toPromise().then(res => {
      return res;
    });
    return resp;

  }
  // async verifyMsg(otp_entered_by_user:any, session_id:any) {
  //   var str = "https://2factor.in/API/V1/" + this.api_key + "/SMS/VERIFY/" + session_id + "/" + otp_entered_by_user
  //   const resp = await this.http.get<any>(str).toPromise().then(res => {
  //     return true
  //   }).catch(err => {
  //     return false
  //   });
  //   return resp;
  // }
  async verifyMsg(otp_entered_by_user: any, session_id: any) {
    let obj: any = new Object();
    obj['otp_no'] = otp_entered_by_user;
    obj['session_id'] = session_id;
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/authentication/verifyOTP', obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getaccountmodule(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/systemdata/legalentity/getaccountmodule', { headers: new HttpHeaders().append('data', await this.mds.dataE(obj)) }).toPromise().then(async res => {
      return await this.mds.dataD(res);
    });
    return resp;
  }

  async getCurrentrole(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/admin/role/getcurrentroles' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getCurrentroleForAccount(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/md/role/getcurrentroles' + obj).toPromise().then(res => {
      return res
    });
    return resp;
  }

  async getCurrentUserFromAdmin(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/admin/user/getcurrentuser' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async getCurrentUserFromMD(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/md/user/getcurrentuser' + JSON.stringify({}), { headers: new HttpHeaders().append('data', await this.mds.dataE(obj)) }).toPromise().then(async res => {
      return await this.mds.dataD(res);
    });
    return resp;
  }

  async loginToAll(obj: any) {
    const isApp = !!((window as any).cordova || (window as any).Capacitor);
    obj['device_type'] = isApp ? 'APP' : 'WEB';

    // Send a dynamically generated device ID if one is not already provided
    if (!obj['device_token']) {
      const fcmToken = await this.fcm.requestToken();
      // if (!fcmToken) {
      //   return { error: true, data: 'Notification permission is required. Please allow notifications (click the lock icon in the address bar if blocked) and try again.' };
      // }
      obj['device_token'] = fcmToken;
    }

    const payload = await this.mds.dataE(obj);
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/authentication/loginToAll', { data: payload }).toPromise().then(res => {
      return this.mds.dataD(res);
    });
    return resp;
  }

  async verifyLoginToAll(obj: any) {
    const payload = await this.mds.dataE(obj);
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/authentication/verifyLoginToAll', { data: payload }).toPromise().then(res => {
      return this.mds.dataD(res);
    });
    return resp;
  }

  async updateSession(obj: any) {
    const payload = await this.mds.dataE(obj);
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/authentication/updateSession', { data: payload }).toPromise().then(res => {
      return this.mds.dataD(res);
    });
    return resp;
  }

  private getErpUserPromise: Promise<any> | null = null;

  async getErpUser(obj: any) {
    if (this.getErpUserPromise) {
      return this.getErpUserPromise;
    }

    const payload = await this.mds.dataE(obj);
    this.getErpUserPromise = this.http.post<any>(this.httpUrl + '/systemdata/authentication/getErpUser', { data: payload }).toPromise().then(res => {
      this.getErpUserPromise = null;
      return this.mds.dataD(res);
    }).catch(err => {
      this.getErpUserPromise = null;
      throw err;
    });

    return this.getErpUserPromise;
  }

  async loginERP(obj: any) {
    const isApp = !!((window as any).cordova || (window as any).Capacitor);
    obj['device_type'] = isApp ? 'APP' : 'WEB';

    // Send a dynamically generated device ID if one is not already provided
    if (!obj['device_token']) {
      const fcmToken = await this.fcm.requestToken();
      // if (!fcmToken) {
      //   return { error: true, data: 'Push Notification permission is required. Please allow notifications (click the lock icon in the address bar if blocked) and try again.' };
      // }
      obj['device_token'] = fcmToken;
    }

    const payload = await this.mds.dataE(obj);
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/authentication/login', { data: payload }).toPromise().then(res => {
      return this.mds.dataD(res);
    }).catch((err: any) => {
      // HTTP error responses (4xx/5xx): the API body is in err.error
      if (err?.error && err.error.hasOwnProperty('error')) {
        return this.mds.dataD(err.error);
      }
      return { error: true, data: 'Unable to connect. Please try again.' };
    });
    // console.log(resp)
    return resp;
  }

  refreshAccessToken(refreshToken: string) {
    return this.http.post<any>(this.httpUrl + '/auth/refresh', { refreshToken });
  }

  async createloginInfo(obj: any) {
    const payload = await this.mds.dataE(obj);
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/loginInfo/createloginInfo', { data: payload }).toPromise().then(res => {
      return this.mds.dataD(res);
    });
    return resp;
  }

  async getDataFromMobileNumberOrEmail(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/getDataFromMobileNumberOrEmail' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async forgetPass(obj: any) {
    const payload = await this.mds.dataE(obj);
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/authentication/forgetpassword', { data: payload }).toPromise().then(res => {
      return this.mds.dataD(res);
    });
    return resp;
  }

  async resetPasswordWithOtp(obj: any) {
    const payload = await this.mds.dataE(obj);
    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/authentication/forgotPassword', { data: payload }).toPromise()
      .then(async res => {
        return await this.mds.dataD(res);
      })
      .catch(async (err: any) => {
        if (err?.error && err.error.hasOwnProperty('error')) {
          return await this.mds.dataD(err.error);
        }
        return { error: true, data: 'Unable to connect. Please try again.' };
      });
    return resp;
  }

  async sendCpatTokenToBackend(token: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/acms/integration/cpatToken', token).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  /**
   * Fetches the RSA key pair used by the frontend for encryption (temppu) and
   * decryption (temppa) of API payloads.
   *
   * Intentionally unauthenticated — this is called during app bootstrap (ngOnInit),
   * before any session exists. Keys are read from the server config (erp2ApiConfig.json)
   * and never hardcoded in the client bundle.
   *
   * Unlike other service methods, this does NOT wrap the response through
   * dataE/dataD because it is the very call that supplies the keys needed for
   * those operations — it cannot be encrypted with a key it hasn't received yet.
   */
  async getEncryptionKeys(): Promise<{ error: boolean; temppu?: string; temppa?: string; message?: string }> {
    const resp = await this.http
      .get<{ error: boolean; temppu?: string; temppa?: string; message?: string }>(
        this.httpUrl + '/systemdata/authentication/keys'
      )
      .toPromise();
    return resp as { error: boolean; temppu?: string; temppa?: string; message?: string };
  }

  logout(refreshToken?: string | null): Promise<any> {
    const token = sessionStorage.getItem('1000');
    const headers: any = {};
    if (token) headers['1000'] = `bearer ${token}`;
    return this.http.post<any>(
      this.httpUrl + '/auth/logout',
      { refreshToken: refreshToken || sessionStorage.getItem('_rt') },
      { headers }
    ).toPromise().catch(() => ({}));
  }

}
